var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"archive-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.downloadFile.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.rowValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }